import { z } from "zod";
import type { ValidationT } from "./i18n";

/**
 * Zod schema for the convert (asset ⇄ peer NFT) dialog form.
 *
 * Factory form (R6 schema-factory): takes a `validation`-namespace translator so
 * error messages resolve through next-intl. Module-scope schemas can't call
 * useTranslations, so the consumer builds this via
 * useMemo(() => makeConvertDialogSchema(t), [t]).
 *
 * Field names (incl. the `shoudlConvertToNFT` typo and the `.default(true)`) are
 * preserved verbatim from the original static schema to keep callers unchanged.
 */
export const makeConvertDialogSchema = (t: ValidationT) =>
  z.object({
    project: z.string().min(1, t("projectRequired")),
    shoudlConvertToNFT: z.boolean().default(true),
    asset: z.string().min(1, t("assetRequired")),
  });

export type ConvertDialogValues = z.infer<
  ReturnType<typeof makeConvertDialogSchema>
>;
